import { Document, Page, StyleSheet  } from '@react-pdf/renderer';
import Form7 from '../../pdfForms/PensionForm7';
import ListOfEnclosure from '../../pdfForms/PensionEnclosure';
import FormAP1 from '../../pdfForms/PensionFormA';
import FormBP1 from '../../pdfForms/FormB/PensionFormBPart1';
import FormBP2 from '../../pdfForms/FormB/PensionFormBPart2';
import FormBP3 from '../../pdfForms/FormB/PensionFormBPart3';
import Form5 from '../../pdfForms/PensionForm5';
import Form6P1 from '../../pdfForms/Form6/PensionForm6P1P1';
import Form6P12 from '../../pdfForms/Form6/PensionForm6P1P2';
import Form6P13 from '../../pdfForms/Form6/PensionForm6P1P3';
import Form6P2 from '../../pdfForms/Form6/PensionForm6P2S1';
import Form6P22 from '../../pdfForms/Form6/PensionForm6P2S2';
import PensionLastPayCertificate from '../../pdfForms/certificates/PensionLastPayCertificate';
import SpecimanSignature from '../../pdfForms/PensionSpecimanSignature';
import Thumb from '../../pdfForms/PensionThumb';
import FamilyDetails from '../../pdfForms/PensionDetailsofFamily';
import Declaration from '../../pdfForms/PensionDeclaration';
import NoDueCertificate from '../../pdfForms/certificates/NoDuesCertificate';
import DepartmentalCertificate from '../../pdfForms/certificates/DepartmentalCertificate';
import ServiceCetificate from '../../pdfForms/certificates/ServiceCetificate';
import AffliationCertificate from '../../pdfForms/certificates/AffliationCertificate';
import Form1 from '../../pdfForms/PensionApprndixV';
import Certificate from '../../pdfForms/certificates/PensionCertificate';
import AnnexureA from '../../pdfForms/PensionAnnexure/PensionAnnexure';
import Annexure2 from '../../pdfForms/PensionAnnexure/PensionAnnexure2';
import RoughCalculation from '../../pdfForms/roughCalculation/PensionRoughCalculation';
import RoughCalculation2 from '../../pdfForms/roughCalculation/PensionRoughCalculation2';
import ServiceHistory from '../../pdfForms/pensionServiceHistory';
import Break from '../../pdfForms/pensionBreak'

import Pramanpatra from '../../pdfForms/MarathiForms/PensionPramanpatra';
import Namuna22 from '../../pdfForms/MarathiForms/PensionNamuna22'
import Padtalni from '../../pdfForms/MarathiForms/PensionSevePadtalni'




const MyDocument = ({ result }) => (
  
  <Document>

    <Page size="A4">
      <AnnexureA result={result}/>
    </Page>

    
    <Page size="A4">  
      <Annexure2 result={result}/>
    </Page>
    
    <Page size="A4">
      <Form7 result={result} />
    </Page>

    <Page size="A4">
      <ListOfEnclosure />
    </Page>


{/* Form A */}  
    <Page size="A4">
      <FormAP1  result={result}/>
    </Page>

{/* Form B */}
  <Page size="A4">
      <FormBP1 result={result}/>
    </Page>

    <Page size="A4">
      <FormBP2 result={result}/>
      <FormBP3 result={result}/>
    </Page>

{/* Form 5 */}
   <Page size="A4">
      <Form5 result={result}/>
    </Page>
    
    <Page size="A4">
      <SpecimanSignature result={result}/>
    </Page>

    <Page size="A4">
      <Thumb result={result}/>
    </Page>

    <Page size="A4">
      <FamilyDetails result={result}/>
    </Page>

  
{/* Form 6 */}
    <Page size="A4">
      <Form6P1 result={result}/>
    </Page>
    
    <Page size="A4">
      <Form6P12 result={result}/>
    </Page>

    <Page size="A4">
      <Form6P13 result={result}/>
    </Page>

    <Page size="A4">
      <Form6P2 result={result}/>
    </Page>
    <Page size="A4">
      <Form6P22 result={result}/>
    </Page>

{/* Form1 */}
    <Page size="A4">
      <Form1 result={result}/>
    </Page>

{/* Last Pay Certificate */}
    <Page size="A4">
      <PensionLastPayCertificate result={result}/>
    </Page>


{/* Rough Calculation */}
    <Page size="A4">
      <RoughCalculation result={result}/>
    </Page>


  <Page size="A4">
     <RoughCalculation2 result={result}/>
  </Page>

{/* Certificates */}
    <Page size="A4" >
      <NoDueCertificate result={result}/>
      <DepartmentalCertificate result={result}/>
    </Page>

    <Page size="A4">
      <Declaration result={result}/>
    </Page>


    <Page size="A4">
      <ServiceCetificate result={result}/>
      <AffliationCertificate result={result}/>
    </Page>


    <Page size="A4">
      <Certificate result={result}/>
    </Page>

    <Page size="A4">
      <Pramanpatra result={result}/>
    </Page>
 
    <Page size="A4">
      <Namuna22 result={result}/>
    </Page>

    <Page size="A4">
      <Padtalni result={result}/>
    </Page >

    <Page size="A4" orientation='landscape'>
      <ServiceHistory result={result}/>
    </Page>

    <Page size="A4" orientation='landscape'>
      <Break result={result}/>
    </Page>


  </Document>
);

export default MyDocument;